module.exports = __webpack_public_path__ + "img/nz.b14c3467.svg";